import React from "react";

function Footer() {

    return (
        <footer className="footer">
            <div className="row g-0 justify-content-between fs-10 mt-4 mb-3">
                <div className="col-12 col-sm-auto text-center">
                    <p className="mb-0 text-600">TOSS, All Rights Reserved <span className="d-none d-sm-inline-block">| </span><br className="d-sm-none" /> 2025&copy; <a href="#/">Powered by AO Holdings</a></p>
                </div>
                <div className="col-12 col-sm-auto text-center">
                    <p className="mb-0 text-600">v1.0.0</p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
